var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletOutlined(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.85,12.55c-2.04,2.23-.94,6.28,2.17,6.72h38.51c.7.04,1.49.46,1.72,1.14l.11,9.86c1.04.26,1.48.85,1.56,1.91.25,3.37-.2,7.06,0,10.47-.1.91-.76,1.45-1.55,1.8l-.11,10.21c-.21.67-.92,1.1-1.61,1.13l-38.98-.02c-3.39-.61-5.44-3.2-5.66-6.58V14.71c.36-3.46,2.8-6.22,6.36-6.48l36.41.1c1.4.61,1.33,2.53-.15,2.99H14.36c-.87.08-1.93.6-2.51,1.24ZM51.51,22.49H14.13c-.31,0-1.29-.26-1.64-.38-.57-.2-1.07-.6-1.63-.81v28.35c0,1.13,2.02,3.03,3.15,3.03h37.5v-8.2h-7.07c-3.66,0-6.37-4.06-6.25-7.44.12-3.16,2.88-6.83,6.25-6.83h7.07v-7.73ZM53.06,33.31h-8.74c-.16,0-1.01.35-1.21.45-2.66,1.39-2.74,5.46-.22,7.04.21.13,1.15.59,1.31.59h8.86v-8.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4,16.51c-.88-.87-.34-2.71.97-2.82h37.33c2.16.44,1.92,3.31-.35,3.34H14.72c-.42-.01-1.03-.23-1.32-.52Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.05,
    cy: 37.31,
    r: 1.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletOutlined);
export default __webpack_public_path__ + "static/media/Wallet-outlined.8b20d81a95633c19372bfaf99c789ff2.svg";
export { ForwardRef as ReactComponent };